import React, {useState} from 'react';
import arrow from './assets/icon-arrow.svg';
import './styles.css';

const App = () => {
  const [years, setYears] = useState('--');
  const [months, setMonths] = useState('--');
  const [days, setDays] = useState('--');

  const handleSubmit = (e) => {
    e.preventDefault();
    const bornDate = e.target[0].value;
    const bornMonth = e.target[1].value;
    const bornYear = e.target[2].value;
    var currentDate = new Date().getDate();
    var currentMonth = new Date().getMonth() + 1;
    var currentYear = new Date().getFullYear();
    

    if(bornDate == ""){
      document.getElementById('required-date').style.display = 'block';
    } else {
      document.getElementById('required-date').style.display = 'none';
    }
    if(bornMonth == ""){
      document.getElementById('required-month').style.display = 'block';
    } else {
      document.getElementById('required-month').style.display = 'none';
    }
    if(bornYear == ""){
      document.getElementById('required-year').style.display = 'block';
    } else {
      document.getElementById('required-year').style.display = 'none';
    }
    if(bornDate > 31){
      document.getElementById('validity-date').style.display = 'block';
    } else {
      document.getElementById('validity-date').style.display = 'none';
    }
    if(bornMonth > 12){
      document.getElementById('validity-month').style.display = 'block';
    } else {
      document.getElementById('validity-month').style.display = 'none';
    }
    if(bornYear > currentYear){
      document.getElementById('validity-year').style.display = 'block';
    } else {
      document.getElementById('validity-year').style.display = 'none';
    }
    if (bornMonth % 2 != 0 && bornDate == 31){
      document.getElementById('validity-date').style.display = 'block';
    } else {
      document.getElementById('validity-date').style.display = 'none';
    }
    if(bornDate == "" || bornDate > 31 || (bornMonth % 2 != 0 && bornDate == 31) ) {
      document.getElementById('date').style.border = '1px solid hsl(0, 100%, 67%)';
      document.getElementById('field-type-date').style.color = 'hsl(0, 100%, 67%)';
    } else {
      document.getElementById('date').style.border = '1px solid hsl(0, 0%, 86%)';
      document.getElementById('field-type-date').style.color = 'hsl(0, 1%, 44%)';
    }
    if (bornMonth == "" || bornMonth > 12) {
      document.getElementById('month').style.border = '1px solid hsl(0, 100%, 67%)';
      document.getElementById('field-type-month').style.color = 'hsl(0, 100%, 67%)';
    } else {
      document.getElementById('month').style.border = '1px solid hsl(0, 0%, 86%)';
      document.getElementById('field-type-month').style.color = 'hsl(0, 1%, 44%)';
    }
    if(bornYear == "" || bornYear > currentYear){
      document.getElementById('year').style.border = '1px solid hsl(0, 100%, 67%)';
      document.getElementById('field-type-year').style.color = 'hsl(0, 100%, 67%)';
    } else {
      document.getElementById('year').style.border = '1px solid hsl(0, 0%, 86%)';
      document.getElementById('field-type-year').style.color = 'hsl(0, 1%, 44%)';
    }
    if(bornDate == "" || bornMonth == "" || bornYear == "" || bornDate > 31 || bornMonth > 12 || bornYear > currentYear || (bornMonth % 2 != 0 && bornDate == 31)){
      setMonths('--');
      setDays('--');
      setYears('--');
    } else {
      if(currentDate < bornDate){
        setDays(currentDate - bornDate + 30);
        currentMonth = currentMonth - 1;
      } else {
        setDays(currentDate - bornDate);
      }
      if(currentMonth < bornMonth) {
        setMonths((currentMonth - bornMonth) + 12);
        currentYear = currentYear - 1;
      } else {
        setMonths(currentMonth - bornMonth);
      }
      setYears(currentYear - bornYear);
    }
  
    }
    

  return (
    <div className='app'>
      <div className='app__card'>
      <form name="form" onSubmit={handleSubmit}>
      <div className='app__card-inputs'>
        <div className='app__card-input' id="date-input" >
          <p className='field-type' id="field-type-date">Day</p>
          <input type="number" id="date" name="date" placeholder='DD'/>
          <p className='required' id="required-date">This field is required</p>
          <p className='validity' id="validity-date">Must be a valid day</p>
        </div>
        <div className='app__card-input' id="month-input">
          <p className='field-type' id="field-type-month">Month</p>
          <input type="number" id="month" name="month" placeholder='MM'/>
          <p className='required' id="required-month">This field is required</p>
          <p className='validity' id="validity-month">Must be a valid month</p>
        </div>
        <div className='app__card-input' id="year-input">
          <p className='field-type' id="field-type-year">Year</p>
          <input type="number" id="year" name="year" placeholder='YYYY'/>
          <p className='required' id="required-year">This field is required</p>
          <p className='validity' id="validity-year">Must be a valid year</p>
        </div>
        </div>
      
      <div className='app__card-btn'>
        <hr />
        <div className='app__card-circle'>
          <input type="submit" value=""/>
        </div>
      </div>
      </form>
      <h1 className='h1-first'><span>{years}</span>years</h1>
      <h1><span>{months}</span>months</h1>
      <h1><span>{days}</span>days</h1>
      </div>
    </div>
  )
}

export default App